import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import ErrorBoundary from "../api/ErrorBoundary";
import SeoLoader from "../components/seo/SeoLoader";
import SomeThingWentWrong from "../components/somethingwentwrong/SomeThingWentWrong";
import { Suspense } from "react";
import { useSelector } from "react-redux";
import FinishCard from "../components/thirdsideCard/FinishCard";

const Layout = () => {
  const globalerror = useSelector(
    (state: { ID: { globalError: boolean } }) => state.ID.globalError
  );

  if (globalerror) return <SomeThingWentWrong />;

  return (
    <ErrorBoundary>
      <SeoLoader />
      <Suspense>
        <Navbar />
        <Outlet />
        <Footer />
        <FinishCard />
      </Suspense>
    </ErrorBoundary>
  );
};

export default Layout;
